export default __webpack_public_path__ + "static/media/TrendDown.56aeebf5.svg";